import BaseNMComAdapter from "../adapters/base.nmcom.adapter";

export default class BaseNMComDataObject {
	makeUrl(method) {
		const urlComponents = BaseNMComAdapter.makeUrlComponents(this, method);
		let url = urlComponents['pieces'].join('/');

		if(urlComponents['extension']) {
			url = `${url}.${urlComponents['extension']}`;
		}

		return url;
	}

	receiveResponse(response, options) {}
}
